export function normalizePortalModulePath(path) {
  const s = String(path ?? '').trim()
  if (!s || s === '/') return '/'
  return s.startsWith('/') ? s : `/${s}`
}
